import { IJobsBoard } from '~/utils/interface/job';
import { Box, Card, CardContent, Link, Typography } from '@mui/material';
import styles from './JobBoardCard.module.scss';
import classNames from 'classnames/bind';
import { DocumentIcon, CalendarIcon } from '~/assets/icons';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { adminRouteAbsolute } from '~/utils/constants/route';

interface Props {
  job: IJobsBoard;
}

function JobBoardCard({ job }: Props) {
  const { t } = useTranslation('admin/job');
  const cx = classNames.bind(styles);
  const navigate = useNavigate();
  return (
    <Box>
      <Card className={cx('container-card')}>
        <CardContent>
          <Box className={cx('card-content')}>
            <Link
              onClick={() => navigate(adminRouteAbsolute.jobDetail.replace(':id', job.id))}
              className='text-[#3A3F51] hover:text-[#007AFC]'
            >
              {job.name}
            </Link>
          </Box>
          <Box className={cx('type-container')}>
            <Box className={cx('card-clock')}>
              <DocumentIcon className={cx('card-icon-clock')} />
              {t('jobBoard.type')}
            </Box>
            <Typography className={cx('type-title')}>{job?.type}</Typography>
          </Box>

          <Box className={cx('card-due-time')}>
            <Box className={cx('card-clock')}>
              <CalendarIcon className={cx('card-icon-clock')} />
              {t('detail.dueDate')}
            </Box>
            <Typography className={cx('card-time')}>
              {job?.createdAt ? dayjs(job.createdAt).format('DD MMM, YYYY') : ''}
            </Typography>
          </Box>

          <Box className={cx('border')}></Box>

          <Box className={cx('avatar-container')}>
            <Box>{job?.customer?.name}</Box>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}

export default JobBoardCard;
